import { memo } from 'react';

export type ReportTableMultilineCellProps = {
  text: string;
  className?: string;
};

/** Nội dung ô bảng báo cáo: xuống dòng khi dài (không ellipsis / tooltip). */
export const ReportTableMultilineCell = memo(function ReportTableMultilineCell({
  text,
  className = '',
}: ReportTableMultilineCellProps) {
  return (
    <span
      className={`block w-full min-w-0 whitespace-normal break-words text-base font-normal text-inherit ${className}`}
    >
      {text}
    </span>
  );
});
